/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Footer = () => {
  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid bg-dark footer mt- py-5 wow fadeIn" data-wow-delay="0.1s" >
        <div className="container py-4">
          <div className="row g-3">
            
            {/* Office */}
            <div className="col-lg-5 col-md-6">
              <h4 className="text-white mb-4">Notre bureau</h4>
              <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>Route 110, Boulevard Chefchaouni – Km 12.5 <br/>Casablanca – 20100, Maroc</p>
              <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>+ 212 (0) 522 202 712  + 212 (0) 6 71 01 88 19 <br/>
                  + 212 (0) 6 79 31 68 71</p>
              <p className="mb-2"><i className="fa fa-envelope me-3"></i>contact@unik-system.com</p>

              <div className="d-flex pt-3">
                <a className="btn btn-square btn-light me-2" href="https://x.com/uniksystem?lang=ar" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a className="btn btn-square btn-light me-2" href="https://www.instagram.com/uniksystem/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a className="btn btn-square btn-light me-2" href="https://www.youtube.com/@UnikSystemMaroc" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
                <a className="btn btn-square btn-light me-2" href="https://www.linkedin.com/company/unik-system/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Liens rapides</h4>
              <a className="btn btn-link" href="/">Accueil</a><br/>
              <a className="btn btn-link" href="/PlafondsMursTendus">Produits</a><br/>
              <a className="btn btn-link" href="/services">Services</a><br/>
              <a className="btn btn-link" href="/devis">Devis</a><br/>
              <a className="btn btn-link" href="/contact">Contact</a>
            </div>

            {/* Business Hours */}
            <div className="col-lg-4 col-md-6">
              <h4 className="text-white mb-4">Heures d'ouverture</h4>
              <p className="mb-1">Du lundi au vendredi</p>
              <h6 className="text-light">08h30 – 12h30 et 14h30 – 18h30</h6>
              <p className="mb-1">Samedi</p>
              <h6 className="text-light">08h30 – 12h30</h6>
              <p className="mb-1">Dimanche</p>
              <h6 className="text-light">Fermée</h6>
            </div>

            
            

          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Copyright */}
<div className="container-fluid copyright py-4">
  <div className="container text-center">
    <div className="row">
      <div className="col-12">
        &copy; <a className="fw-medium" style={{color:"#EE2D2B"}} href="/">UNIK SYSTEM</a>, Tous droits réservés.
      </div>
    </div>
  </div>
</div>

    </>
  );
};

export default Footer;
